if (!customElements.get('pl-dsx-addons')) {
  customElements.define('pl-dsx-addons', class extends HTMLElement {
    connectedCallback() {
      this.changeHandler = () => this.refresh();
      this.productInfo = this.closest('product-info');
      this.productInfo.addEventListener('change', this.changeHandler);
      this.refresh();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.changeHandler);
    }
    refresh() {
      const state = this.querySelector('[data-base-price]');
      const mode = this.querySelector('[data-pl-device]:checked').value;
      const extra = mode === 'own' ? 0 : Number(this.dataset.devicePrice) + (mode === 'credits' ? 8 * Number(this.dataset.creditPrice) : 0);
      const amount = (Number(state.dataset.basePrice) + extra) / 100;
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency}).format(amount);
      const priceText = formatted + (this.dataset.currencyCodeEnabled === 'true' ? ' ' + this.dataset.currency : '');
      const price = this.productInfo.querySelector('[id^="price-"]');
      price?.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(element => {
        element.textContent = priceText;
      });
      const installments = this.productInfo.querySelector('form.installment');
      if (installments) installments.hidden = mode !== 'own';
      const custom = state.dataset.hardware.includes('custom harness');
      const group = this.productInfo.querySelector('[data-pl-harness]');
      if (!group) return;
      group.hidden = !custom;
      group.querySelector('input').disabled = !custom;
      group.querySelector('input').required = custom;
    }
    buildItems(formData) {
      const mode = this.querySelector('[data-pl-device]:checked').value;
      const quantity = Number(formData.get('quantity') || 1);
      const properties = {};
      for (const [key,value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      properties['Tuning device'] = this.querySelector('[data-pl-device]:checked').labels[0].textContent.trim();
      const items = [{id:formData.get('id'),quantity,properties}];
      if (mode !== 'own') items.push({id:this.dataset.deviceId,quantity});
      if (mode === 'credits') items.push({id:this.dataset.creditId,quantity:8 * quantity});
      return items;
    }
  });
}

